/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Reporting
 * API for Vault Reporting
 *
 * The version of the OpenAPI document: 2025-05-05
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.ts';
/**
 * PaginationResponse is the response holding the page tokens for a paginated
 * list response.
 * @export
 * @interface CommonPaginationResponse
 */
export interface CommonPaginationResponse {
    /**
     * This token allows you to get the next page of results for list requests.
     * If the number of results is larger than `page_size`, use the
     * `next_page_token` as a value for the query parameter `next_page_token` in
     * the next request. The value will become empty when there are no more pages.
     * @type {string}
     * @memberof CommonPaginationResponse
     */
    nextPageToken?: string;
    /**
     * This token allows you to get the previous page of results for list
     * requests. If the number of results is larger than `page_size`, use the
     * `previous_page_token` as a value for the query parameter
     * `previous_page_token` in the next request. The value will become empty when
     * there are no more pages.
     * @type {string}
     * @memberof CommonPaginationResponse
     */
    previousPageToken?: string;
}

/**
 * Check if a given object implements the CommonPaginationResponse interface.
 */
export function instanceOfCommonPaginationResponse(value: object): value is CommonPaginationResponse {
    return true;
}

export function CommonPaginationResponseFromJSON(json: any): CommonPaginationResponse {
    return CommonPaginationResponseFromJSONTyped(json, false);
}

export function CommonPaginationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommonPaginationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nextPageToken': json['next_page_token'] == null ? undefined : json['next_page_token'],
        'previousPageToken': json['previous_page_token'] == null ? undefined : json['previous_page_token'],
    };
}

export function CommonPaginationResponseToJSON(json: any): CommonPaginationResponse {
    return CommonPaginationResponseToJSONTyped(json, false);
}

export function CommonPaginationResponseToJSONTyped(value?: CommonPaginationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next_page_token': value['nextPageToken'],
        'previous_page_token': value['previousPageToken'],
    };
}

